import { SHARE_ENABLED } from '@muzly/shared';

import { DeleteAction } from './DeleteAction';
import { ShareAction } from './ShareAction';

/**
 * 결과 상세 헤더의 오른쪽 버튼 묶음 — 이 회차 삭제 · 공유.
 *
 * 공유는 `SHARE_ENABLED` 플래그가 켜졌을 때만 선다(기본 꺼짐 — 플래그 주석). 두 버튼 모두 저장된
 * 레코드를 스스로 읽어 서고 사라지므로 여기는 자리만 정한다.
 */
export const ResultHeaderActions = ({ recordId }: { recordId: string }) => (
  <div className="flex items-center">
    <DeleteAction recordId={recordId} />
    {SHARE_ENABLED && <ShareAction recordId={recordId} />}
  </div>
);
